import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

export const useVerifyPhone = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: verifyPhone,
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ['customer', 'account'] }),
  });
};

const verifyPhone = async (props: VerifyPhoneBody) =>
  api.put<void>(apiConfig.routes.auth.verifyPhone, props);

type VerifyPhoneBody = {
  phone: string;
  token: string;
};
